export default __webpack_public_path__ + "static/media/planet_planeta_1.88e5f9ff.png";